export var WalletManagementType;
(function (WalletManagementType) {
    WalletManagementType["CUSTODIAL"] = "custodial";
    WalletManagementType["NON_CUSTODIAL"] = "non-custodial"; // Client-side signing
})(WalletManagementType || (WalletManagementType = {}));
export var WalletStatus;
(function (WalletStatus) {
    WalletStatus["PENDING"] = "pending";
    WalletStatus["ACTIVE"] = "active";
    WalletStatus["SUSPENDED"] = "suspended";
    WalletStatus["ARCHIVED"] = "archived";
})(WalletStatus || (WalletStatus = {}));
//# sourceMappingURL=wallet.enum.js.map